import React from "react";
import {Box, Typography} from "@mui/material";
import {TimerComponent} from "./TimerComponent.tsx";

interface StatsComponentProps {
	readonly currentCount: number;
	readonly maxCount: number;
	readonly timerDuration: number;
	readonly timerRunning: boolean;
	readonly onElapse: () => void;
}

export function StatsComponent(props: StatsComponentProps): React.ReactElement {
	return <Box sx={{
		my: 3,
		display: "flex",
		gap: 3,
		justifyContent: "center"
	}}>
		<Typography variant="h4">
			{props.currentCount} / {props.maxCount}
		</Typography>
		<TimerComponent
			duration={props.timerDuration}
			onElapse={props.onElapse}
			running={props.timerRunning}
		/>
	</Box>
}